import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const TEAMS_TEAM_LINEUPS_FETCH = 'TEAMS_TEAM_LINEUPS_FETCH'
export const TEAMS_TEAM_LINEUPS_FETCH_CANCELED = 'TEAMS_TEAM_LINEUPS_FETCH_CANCELED'
export const TEAMS_TEAM_LINEUPS_FETCH_ERROR = 'TEAMS_TEAM_LINEUPS_FETCH_ERROR'
export const TEAMS_TEAM_LINEUPS_FETCH_FULFILLED = 'TEAMS_TEAM_LINEUPS_FETCH_FULFILLED'

export const teamLineupsFetch = (teamId) => ({
  payload: { teamId },
  type: TEAMS_TEAM_LINEUPS_FETCH,
})

export const teamLineupsFetchFulfilled = (payload) => ({
  payload,
  type: TEAMS_TEAM_LINEUPS_FETCH_FULFILLED,
})

export const teamLineupsFetchCanceled = () => ({
  payload: null,
  type: TEAMS_TEAM_LINEUPS_FETCH_CANCELED,
})

export const teamLineupsFetchError = (payload) => ({
  payload,
  type: TEAMS_TEAM_LINEUPS_FETCH_ERROR,
})

export const teamLineupsFetchEpic = (action$) =>
  action$.pipe(
    ofType(TEAMS_TEAM_LINEUPS_FETCH),
    mergeMap((action) =>
      epicServerRequest('get', `${APP.api_url}/sports/soccer/team/${action.payload.teamId}/lineups`, action).pipe(
        map(epicResponseHandler(teamLineupsFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(TEAMS_TEAM_LINEUPS_FETCH, TEAMS_TEAM_LINEUPS_FETCH_CANCELED))),
        catchError(epicErrorHandler(teamLineupsFetchError, action)),
      ),
    ),
  )
